import axios from 'axios'

//出皮统计列表(报表)
export function getSkinList (data) {
  return axios.get(`/manage/report/skinPeelingCount`, { params: data })
}

//出皮统计列表(下钻明细数据)
export function getSkinDetailList (data) {
  return axios.get(`/manage/report/querySkinPeelingDetals`, { params: data })
}

//出皮统计(基础信息,鲜皮信息,干皮信息)
export function getSkinDetail (data) {
  return axios.get(`/manage/report/querySkinPeelingComprehen`, { params: data })
}

//查询标签打印列表PC(报表)
export function getPrintPcList (data) {
  return axios.get(`/manage/report/queryLabelPrintPcList`, { params: data })
}
//扫码溯源(
export function getTraceabilityNode (data) {
  return axios.get(`/manage/report/queryTraceabilityNode`, { params: data })
}

//干皮验收列表查询
export function getDrySkinReceiptList (data) {
  return axios.get(`/manage/report/selectDrySkinAccept`, { params: data })
}

//干皮验收下钻明细列表
export function getDrySkinReceiptDetail (data) {
  return axios.get(`/manage/report/selectDrySkinAcceptDetail`, { params: data })
}

//查询出库单详情
export function getDryInboundData (data) {
  return axios.get(`/manage/report/getDryInboundData`, { params: data })
}